document.addEventListener('DOMContentLoaded', () => {
  // header navigation start
  const menu_Items = document.querySelectorAll('.header__inline-menu [data-menu-item]');
  const drawerMenu = document.querySelector('.oddit-menu-drawer');

  function closeMenu() {
    drawerMenu?.classList.remove('menu-open');
    document.body.classList.remove('menu-overflow-hidden');
    menu_Items.forEach((el) => el.classList.remove('active'));
    drawerMenu?.querySelectorAll('[data-menu-item]').forEach((el) => el.classList.remove('open'));
  }

  menu_Items.forEach((item) => {
    item.addEventListener('click', (navItem) => {
      const isActive = navItem.currentTarget.classList.contains('active');

      if (isActive) {
        closeMenu();
        return;
      }

      menu_Items.forEach((el) => el.classList.remove('active'));
      navItem.currentTarget.classList.add('active');

      const itemValue = navItem.currentTarget.dataset.menuItem;

      if (drawerMenu) {
        const drawerItems = drawerMenu.querySelectorAll('[data-menu-item]');
        drawerItems.forEach((drawerItem) => {
          if (drawerItem.dataset.menuItem === itemValue) {
            drawerItem.classList.add('open');
          } else {
            drawerItem.classList.remove('open');
          }
        });

        drawerMenu.classList.add('menu-open');
      }

      document.body.classList.add('menu-overflow-hidden');
    });
  });

  document.addEventListener('click', (event) => {
    if (
      drawerMenu &&
      !event.target.closest('.dmd-wrapper') &&
      !event.target.closest('.header__inline-menu [data-menu-item]') // and not on a menu item
    ) {
      closeMenu();
    }
  });

  const mmToggle = document.querySelector('.mm-menu');

  if (mmToggle) {
    mmToggle.addEventListener('click', (event) => {
      const isActive = event.currentTarget.classList.contains('mm-active');
      if (isActive) {
        event.currentTarget.classList.remove('mm-active');
        drawerMenu?.classList.remove('mm-menu-open');
        document.body.classList.remove('mm-overflow-hidden');
      } else {
        event.currentTarget.classList.add('mm-active');
        drawerMenu?.classList.add('mm-menu-open');
        document.body.classList.add('mm-overflow-hidden');
      }
    });
  }

  const announcement = document.querySelector('.announcement-bar-section');
  const header = document.querySelector('.section-header');

  if (!announcement || !header) return;

  const announcementHeight = announcement.offsetHeight;
  const headerHeight = header.offsetHeight;
  const totalHeight = announcementHeight + headerHeight;

  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;

    if (scrollY < totalHeight) {
      const remainingHeight = totalHeight - scrollY;
      document.body.classList.add('below-total-height');
      // You can also expose remaining height as a CSS variable if needed:
      document.body.style.setProperty('--remaining-header-height', `${remainingHeight}px`);
    } else {
      document.body.classList.remove('below-total-height');
      document.body.style.removeProperty('--remaining-header-height');
    }
  });
  // header navigation end

  const animationButtons = document.querySelectorAll('.button');

  animationButtons.forEach((button) => {
    button.addEventListener('click', function (event) {
      this.classList.add('has-animation');
      if (this.tagName.toLowerCase() === 'a' && this.href) {
        event.preventDefault();
        const url = this.href;
        setTimeout(() => {
          window.location.href = url;
        }, 1000);
      }
    });
  });

  const imageBlocks = document.querySelectorAll('.animation-image-content .animation-image-blocks');
  if (imageBlocks.length > 0) {
    imageBlocks.forEach((block) => {
      block.addEventListener('click', (event) => {
        block.closest('.animation-image-content').classList.add('has-animation');
        const anchor = block.querySelector('a');
        if (anchor && anchor.href) {
          event.preventDefault();

          const url = anchor.href;
          setTimeout(() => {
            window.location.href = url;
          }, 1000);
        }
        setTimeout(() => {
          block.closest('.animation-image-content').classList.remove('has-animation');
        }, 1200);
      });
    });
  }

  const imageButtonBlocks = document.querySelectorAll('.animation-image-content .button');
  if (imageButtonBlocks.length > 0) {
    imageButtonBlocks.forEach((block) => {
      block.addEventListener('click', () => {
        block.closest('.animation-image-content').classList.add('has-animation');
        setTimeout(() => {
          block.closest('.animation-image-content').classList.remove('has-animation');
        }, 1200);
      });
    });
  }

  const menuBlock = document.querySelectorAll('.menu-child-list .menu-child-item');
  if (menuBlock.length > 0) {
    menuBlock.forEach((block) => {
      const menuChildLink = block.querySelector('.menu-child-link');
      block.addEventListener('click', (event) => {
        event.preventDefault();
        if (menuChildLink && menuChildLink.getAttribute('href')) {
          setTimeout(() => {
            window.location.href = menuChildLink.getAttribute('href');
          }, 800);
        }
        block.classList.add('has-animation');
        setTimeout(() => {
          block.classList.remove('has-animation');
        }, 1200);
      });
    });
  }

  const productImage = document.querySelectorAll('.linked-product .linked-product-item .featured-image');
  if (productImage.length > 0) {
    productImage.forEach((block) => {
      block.addEventListener('click', () => {
        block.classList.add('has-animation');
        setTimeout(() => {
          block.classList.remove('has-animation');
        }, 1000);
      });
    });
  }

  const productButton = document.querySelectorAll('.shop-products .product-image-slider .swiper-slide');
  if (productButton.length > 0) {
    productButton.forEach((block) => {
      block.addEventListener('click', () => {
        block.closest('.product-swiper-wrapper').classList.add('has-animation');
        setTimeout(() => {
          block.closest('.product-swiper-wrapper').classList.remove('has-animation');
        }, 1000);
      });
    });
  }
});
